module.exports = __webpack_public_path__ + "img/1528468676.96d231ac.jpg";